var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main" },
            [
              _c("SubTitleComponent", { attrs: { title: _vm.title } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _vm.global.type == "manage"
                    ? _c(
                        "el-row",
                        { staticClass: "tools", attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4, offset: 16 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success", plain: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toPath("/customernew")
                                    }
                                  }
                                },
                                [_vm._v("编辑客户信息")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success", plain: "" },
                                  on: { click: _vm.toDelete }
                                },
                                [_vm._v("删除客户")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-descriptions",
                    {
                      attrs: {
                        title: "",
                        direction: "vertical",
                        column: _vm.global.type == "manage" ? 5 : 6,
                        border: ""
                      }
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "行业类型" } },
                        [_vm._v(_vm._s(_vm.customerData.industry_type))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "项目类型" } },
                        [_vm._v(_vm._s(_vm.customerData.project_type))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "项目面积" } },
                        [
                          _vm._v(
                            _vm._s(_vm.customerData.project_area) + "平方米"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "项目联系人" } },
                        [_vm._v(_vm._s(_vm.customerData.contact_neme))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "联系方式" } },
                        [_vm._v(_vm._s(_vm.customerData.contact_phone))]
                      ),
                      _vm._v(" "),
                      _vm.global.type == "client"
                        ? _c(
                            "el-descriptions-item",
                            {
                              attrs: { label: "更多", labelStyle: "width:20%;" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.toPath("/effectcollect")
                                    }
                                  }
                                },
                                [_vm._v("查看收藏")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.renderData, function(item, index) {
                    return _vm.renderData.length > 0
                      ? _c(
                          "div",
                          { key: item.id, staticClass: "spaceBox" },
                          [
                            _c("div", { staticClass: "spaceName" }, [
                              _vm._v(
                                _vm._s(
                                  item.space_type + "(" + item.count + "张)"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "date" }, [
                              _vm._v(_vm._s(item.date))
                            ]),
                            _vm._v(" "),
                            _c("el-divider"),
                            _vm._v(" "),
                            _vm._l(item.model, function(itemM, indexM) {
                              return _c(
                                "div",
                                { staticClass: "modelBox" },
                                [
                                  _c("div", { staticClass: "modelName" }, [
                                    _vm._v(
                                      _vm._s(
                                        itemM.model_name +
                                          "(" +
                                          itemM.count +
                                          "张)"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(itemM.workblank, function(
                                    itemW,
                                    indexW
                                  ) {
                                    return _c(
                                      "div",
                                      { staticClass: "mediaF" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "mediaBox" },
                                          [
                                            _c("div", { staticClass: "item" }, [
                                              _c("img", {
                                                attrs: {
                                                  src: itemW.photo_url,
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "mediaName" },
                                                [_vm._v("毛坯图")]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              itemW.effect_result,
                                              function(itemS, indexS) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass: "item",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toDetail(
                                                          index,
                                                          indexM,
                                                          indexW,
                                                          indexS
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    itemS.file_type == 0
                                                      ? _c("img", {
                                                          attrs: {
                                                            src:
                                                              itemS.file_url +
                                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    itemS.file_type == 1
                                                      ? _c("video", {
                                                          attrs: {
                                                            src: itemS.file_url,
                                                            alt: "",
                                                            poster:
                                                              itemW.photo_url +
                                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "type" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            itemS.file_type == 0
                                                              ? "生成效果图"
                                                              : itemS.file_type ==
                                                                1
                                                              ? "图生视频"
                                                              : "AI改图"
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    itemS.file_type == 1
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "play"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../assets/ico_play.png"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass: "mediaName"
                                                    })
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        indexM != item.model.length - 1
                                          ? _c("el-divider")
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.renderData.length <= 0
                    ? _c(
                        "div",
                        { staticClass: "list" },
                        [
                          _c("el-empty", { attrs: { description: "暂无数据" } })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisit,
                    width: "60%",
                    "show-close": true,
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisit = $event
                    }
                  }
                },
                [
                  _vm.dialogCur[0] != -1
                    ? _c("div", { staticClass: "img" }, [
                        _vm.renderData[_vm.dialogCur[0]].model[_vm.dialogCur[1]]
                          .workblank[_vm.dialogCur[2]].effect_result[
                          _vm.dialogCur[3]
                        ].file_type == 0
                          ? _c("img", {
                              attrs: {
                                src:
                                  _vm.renderData[_vm.dialogCur[0]].model[
                                    _vm.dialogCur[1]
                                  ].workblank[_vm.dialogCur[2]].effect_result[
                                    _vm.dialogCur[3]
                                  ].file_url,
                                alt: ""
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.renderData[_vm.dialogCur[0]].model[_vm.dialogCur[1]]
                          .workblank[_vm.dialogCur[2]].effect_result[
                          _vm.dialogCur[3]
                        ].file_type == 1
                          ? _c("video", {
                              attrs: {
                                src:
                                  _vm.renderData[_vm.dialogCur[0]].model[
                                    _vm.dialogCur[1]
                                  ].workblank[_vm.dialogCur[2]].effect_result[
                                    _vm.dialogCur[3]
                                  ].file_url,
                                poster:
                                  _vm.renderData[_vm.dialogCur[0]].model[
                                    _vm.dialogCur[1]
                                  ].workblank[_vm.dialogCur[2]].photo_url,
                                alt: "",
                                controls: ""
                              }
                            })
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dialogCur[0] != -1
                    ? _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _vm.renderData[_vm.dialogCur[0]].model[
                            _vm.dialogCur[1]
                          ].workblank[_vm.dialogCur[2]].effect_result[
                            _vm.dialogCur[3]
                          ].workblank_id == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "success", plain: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toPath("/effectvideo")
                                    }
                                  }
                                },
                                [_vm._v("图生视频")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.renderData[_vm.dialogCur[0]].model[
                            _vm.dialogCur[1]
                          ].workblank[_vm.dialogCur[2]].effect_result[
                            _vm.dialogCur[3]
                          ].workblank_id == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "success", plain: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toPath("/effectaiedit")
                                    }
                                  }
                                },
                                [_vm._v("AI改图")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.renderData[_vm.dialogCur[0]].model[
                            _vm.dialogCur[1]
                          ].workblank[_vm.dialogCur[2]].effect_result[
                            _vm.dialogCur[3]
                          ].workblank_id == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon:
                                      _vm.renderData[_vm.dialogCur[0]].model[
                                        _vm.dialogCur[1]
                                      ].workblank[_vm.dialogCur[2]]
                                        .effect_result[_vm.dialogCur[3]]
                                        .favorite == 0
                                        ? "el-icon-star-off"
                                        : "el-icon-star-on",
                                    plain: ""
                                  },
                                  on: { click: _vm.toFavorite }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.renderData[_vm.dialogCur[0]].model[
                                        _vm.dialogCur[1]
                                      ].workblank[_vm.dialogCur[2]]
                                        .effect_result[_vm.dialogCur[3]]
                                        .favorite == 0
                                        ? "收藏"
                                        : "取消收藏"
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", plain: "" },
                              on: { click: _vm.toDownload }
                            },
                            [_vm._v("下载")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82fdd110", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82fdd110","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Customer/Detail.vue
// module id = null
// module chunks = 